import BaseService from './baseService'
import { User } from '@/types/user'

class UserService extends BaseService {
  getCurrentUser = async (): Promise<User> => {
    const response: { data: { user: User; roleIds?: number[] } } =
      await this.apiClient.get('users/me')
    const { user, roleIds } = response.data
    return {
      ...user,
      roleIds: roleIds || user.roleIds || [],
      isSignedIn: true
    }
  }

  getUserData = async (emailAddress: string): Promise<User> => {
    const response: { data: User } = await this.apiClient.get('users', {
      email: emailAddress
    })
    return response.data
  }

  getBpUsers = async (businessProfileIds: number | null): Promise<User[]> => {
    const response: { data: User[] } = await this.apiClient.get('users', {
      businessProfileIds
    })
    return response.data
  }

  getUserById = async (userId: string | number): Promise<User> => {
    const response: { data: User[] } = await this.apiClient.get('users', {
      ids: userId
    })
    return response.data[0]
  }
}

export const userService = new UserService()
export default UserService
